import Container from "components/Container";
import React, { useEffect, useState, Fragment } from "react";
import liveClassService from "services/liveClass";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineDownload } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { FetchCourseLesson } from "redux/actions/Course";
import { s3BaseUrl } from "api/Consts";
const COKE_COURSE_ID = 302;
export default function ResourceView(props) {
  const dispatch = useDispatch();

  const auth = useSelector(({ auth }) => auth);
  const userId = auth.user?.db_user?.id;
  const {
    lessonName,
    completion_criteria,
    courseName,
    module_resources,
    course_id,
    description,
    user_id,
  } = props.modData;
  const [inlineResource, setInlineResource] = useState(null);
  const isCoke = Number(course_id) === COKE_COURSE_ID;
  useEffect(() => {
    if (props.modData?.completion_criteria === 2) {
      markComplete(props.modData);
    }
  }, [props.modData]);

  useEffect(() => {
    setInlineResource(null);
  }, [lessonName]);

  const markComplete = async (data) => {
    console.log(
      "checkCourseCompleteAudit",
      "In ResourceView.js, invoked markComplete",
    );
    if (data.completionStatus) return false;

    console.log(
      "checkCourseCompleteAudit",
      "Calling liveClassService.ManuallyMarkComplete",
    );
    await liveClassService.ManuallyMarkComplete(data, userId);

    console.log("checkCourseCompleteAudit", "Dispatching FetchCourseLesson");
    dispatch(FetchCourseLesson(data.course_id, userId));
  };
  const extractScormUrl = (text) => {
    const match = text.match(
      /https:\/\/courses\.skillindiadigital\.gov\.in\/media\/scorm\/[a-z0-9]+\/story\.html/,
    );
    return match ? match[0] : null;
  };
  const downloadFile = async (file_name) => {
    const url = `${s3BaseUrl}/${file_name}`;
    if (isCoke) {
      if (file_name.toLowerCase().endsWith(".rtf")) {
        const res = await fetch(url);
        const text = await res.text();

        const scormUrl = extractScormUrl(text);

        if (scormUrl) {
          setInlineResource(scormUrl);
          return;
        }
      }
      setInlineResource(s3BaseUrl + "/" + file_name);
    } else {
      window.open(s3BaseUrl + "/" + file_name, "_blank");
    }
  };
  const getFileType = (url) => {
    if (!url) return null;
    if (url.includes("story.html") || url.includes("/scorm/")) {
      return "scorm";
    }
    const ext = url.split(".").pop().toLowerCase().split("?")[0];
    if (["pdf"].includes(ext)) return "pdf";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (["mp3", "wav"].includes(ext)) return "audio";
    if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(ext))
      return "image";
    if (["doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(ext))
      return "office";
    return "other";
  };

  const InlineViewer = ({ url }) => {
    const fileType = getFileType(url);
    if (fileType === "scorm") {
      return (
        <iframe
          src={url}
          className="w-full mt-4 border-0"
          style={{ height: "85vh" }}
          title="SCORM Content"
          allowFullScreen
        />
      );
    }

    if (fileType === "pdf") {
      return (
        <div className="w-full mt-4 rounded-lg overflow-hidden shadow-lg">
          <iframe
            src={url}
            className="w-full"
            style={{ height: "80vh" }}
            title="Resource Viewer"
          />
        </div>
      );
    }

    if (fileType === "video") {
      return (
        <div className="w-full mt-4 rounded-lg overflow-hidden shadow-lg">
          <video controls className="w-full" src={url}>
            Your browser does not support the video tag.
          </video>
        </div>
      );
    }

    if (fileType === "audio") {
      return (
        <div className="w-full mt-4 p-4 bg-white rounded-lg shadow-lg">
          <audio controls className="w-full" src={url}>
            Your browser does not support the audio tag.
          </audio>
        </div>
      );
    }

    if (fileType === "image") {
      return (
        <div className="w-full mt-4 rounded-lg overflow-hidden shadow-lg flex justify-center bg-white p-4">
          <img
            src={url}
            alt="Resource"
            className="max-w-full max-h-screen object-contain"
          />
        </div>
      );
    }
  };
  return (
    <Container>
      <div className="p-2">
        <h1 className="text-4xl text-center font-semibold leading-10 text-japanese_indigo mb-6">
          {lessonName}
        </h1>
        <h2 className="text-center font-bold text-xl mb-4">
          {isCoke ? "View Resources" : "Download Resources"}
        </h2>
      </div>
      <div className="w-full bg-white rounded-lg shadow-lg">
        <ul className="divide-y-2 divide-gray-400 border-b	border-black-500  bg-gray-300">
          {(module_resources || []).map((e, i) => {
            return (
              <li
                key={e.id}
                className="flex justify-between p-3 hover:bg-orange hover:text-white"
              >
                {e.actual_file_name}
                <div className="flex justify-end gap-3 p-3 hover:bg-orange hover:text-white">
                  {isCoke && (
                    <FaEye
                      className="cursor-pointer mr-0"
                      size={22}
                      onClick={() => downloadFile(e.file_name)}
                    />
                  )}
                  {!isCoke && (
                    <AiOutlineDownload
                      className="cursor-pointer mr-0"
                      size={22}
                      onClick={() => downloadFile(e.file_name)}
                    />
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      {isCoke && inlineResource && (
        <div className="mt-4">
          <div className="flex justify-between mb-2">
            <h3 className="font-semibold">Resource Preview</h3>
            <button
              onClick={() => setInlineResource(null)}
              className="text-sm underline"
            >
              Close
            </button>
          </div>

          <InlineViewer url={inlineResource} />
        </div>
      )}
    </Container>
  );
}
